import { TableToolbarSearch as CarbonTableToolbarSearch } from "@carbon/react";
import { FC } from "react";

import { useT } from "src/internationalization";

export type TableToolbarSearchProps = {
  id?: string;
  onSearchChange: (search: string) => void;
  search: string;
  placeholder?: string;
};

export const TableToolbarSearch: FC<TableToolbarSearchProps> = ({
  onSearchChange,
  search,
  id,
  placeholder,
}) => {
  const t = useT();

  return (
    <CarbonTableToolbarSearch
      id={id}
      labelText={t("general.search.placeholder")}
      placeholder={placeholder ?? t("general.search.placeholder")}
      persistent={true}
      data-modal-primary-focus
      onClear={() => onSearchChange("")}
      onChange={(e) => {
        if (typeof e === "string") {
          return;
        }

        if (e.target instanceof HTMLInputElement) {
          onSearchChange(e.target.value);
        }
      }}
      defaultValue={search}
    />
  );
};
